// @ts-nocheck

export type LocationFilter = {
  state?: string
  city?: string
}

export const normalizeLocation = (
  location: string | LocationFilter | undefined | null
): LocationFilter | undefined => {
  if (!location) {
    return undefined
  }

  if (typeof location === 'string') {
    return location ? { city: location } : undefined
  }

  if (!location.state && !location.city) {
    return undefined
  }

  return {
    ...(location.state && { state: location.state }),
    ...(location.city && { city: location.city })
  }
}

export const hasLocationFilter = (
  location: string | LocationFilter | undefined | null
): boolean => {
  const normalized = normalizeLocation(location)
  return Boolean(normalized?.state || normalized?.city)
}

export const getLocationDisplayLabel = (
  location: string | LocationFilter | undefined | null,
  stateOptions?: { value: string; label: string }[]
): string | undefined => {
  const normalized = normalizeLocation(location)
  if (!normalized) {
    return undefined
  }

  if (normalized.city) {
    return normalized.city
  }

  if (normalized.state) {
    const stateLabel = stateOptions?.find(
      (option) => option.value === normalized.state
    )?.label
    return stateLabel ?? normalized.state
  }

  return undefined
}
